// CSS
import './FullScreenModal.css';
// React hooks
import ReactDOM from "react-dom";


// represents the top-level HTML element to render FullScreenModal into
const modalRoot = document.getElementById("modal-root");



// ===============
// FullScreenModal - the top-level overlay for rendering many (not all) other Modals into.
// ===============
function FullScreenModal({
    isOpen,     // bool – is this Component open?
    onClose,    // ()   – callback function that runs when this Component closes.
    children,   // T    – the inner React Object that's displayed inside of this Component. 
}){
    // JSX Component (Edge case: If !isOpen, never render this Component)
    if (!isOpen) return null;

    // ==============================
    // Handle Clicking off this Modal
    // ==============================
    const handleClickOff = () => {
        onClose();
    }

    // JSX Component in React Portal
    return ReactDOM.createPortal(
        // Override/take up the entire screen.
        <div className='FullScreenModal' onClick={handleClickOff}>

            {/* Render the children passed into this <FullScreenModal/> */}
            <div className='FullScreenModal-content' onClick={(e) => e.stopPropagation()}>{children}</div>

        </div>,
        modalRoot // Attach the rendered element to the modalRoot HTML element (located within the top-level index.html file)
    );
}


// Export statement
export default FullScreenModal;